import { groupBy, mapValues } from 'lodash-es';

export function getCategoryGroupedOptions(values, type) {
  const groups = groupBy(values, 'category');
  let optionsGrouped = {};

  const { popular, other } = mapValues(groups, groupValues =>
    groupValues.map(groupValue => ({
      ...groupValue,
      name: groupValue.isChild ? `-- ${groupValue.name}` : groupValue.name,
    }))
  );
  // Hack to return popular models first
  optionsGrouped = {
    ...(popular ? { [`Popular ${type}`]: popular } : {}),
    ...(other ? { [`Other ${type}`]: other } : {}),
  };

  return optionsGrouped;
}
